import { facets } from "../facets.js";
import { convertFacet } from "../units-conversion.js";
import { attachColumnFormatValue } from "../number-formatting.js";

export const createTableColumns = (columns, { formatNumbers = false } = {}) => {
  return columns
    .map((c) => {
      if (!facets[c.key]) {
        return false;
      }
      const facet = convertFacet(facets[c.key]);
      const column = {
        ...facet,
        key: c.key,
        label: facet.label_column ?? facet.label,
      };
      if (facet.sortable) {
        column.ascIndex = `${algolia.product_index_name}_${facet.originalAttribute}_asc`;
        column.descIndex = `${algolia.product_index_name}_${facet.originalAttribute}_desc`;
      }
      if (formatNumbers) {
        attachColumnFormatValue(column, facet, c);
      }
      return column;
    })
    .filter((a) => a);
};
